/** The driven port of the application for sending telemetry data. */
export abstract class TelemetryService {
  abstract pageView(path: string): Promise<void>;
  abstract event(name: string, params?: Record<string, unknown>): Promise<void>;
  abstract timing(name: string, value: number): Promise<void>;
}
